export function userLoginChanged(payload) {
    return { type: 'USER_LOGIN_CHANGED', payload };
}
